var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1117_5025)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1117_5025",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1117_5025)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2044 7.73856L6.65907 12.284C6.21972 12.7233 6.21972 13.4357 6.65907 13.875C7.09842 14.3143 7.81062 14.3143 8.24997 13.875L10.8749 11.25V21.375C10.8749 21.9963 11.3786 22.5 11.9999 22.5C12.6212 22.5 13.1249 21.9963 13.1249 21.375V11.25L15.7498 13.875C16.1892 14.3143 16.9016 14.3143 17.3409 13.875C17.7803 13.4357 17.7803 12.7233 17.3409 12.284L12.7954 7.73856C12.3561 7.29921 11.6438 7.29921 11.2044 7.73856ZM4.875 18.75C5.49631 18.75 6 19.2537 6 19.875C6 20.4963 5.49631 21 4.875 21H3C1.34315 21 -1.44846e-07 19.6569 0 18L1.31135e-06 3C1.45619e-06 1.34315 1.34315 -1.4484e-07 3 0L21 1.57361e-06C22.6569 1.71846e-06 24 1.34315 24 3V18C24 19.6569 22.6569 21 21 21H19.125C18.5037 21 18 20.4963 18 19.875C18 19.2537 18.5037 18.75 19.125 18.75H21C21.4142 18.75 21.75 18.4142 21.75 18V3C21.75 2.58579 21.4142 2.25 21 2.25H3C2.58579 2.25 2.25 2.58579 2.25 3V18C2.25 18.4142 2.58579 18.75 3 18.75H4.875Z",
    fill: "#42474D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1117_5025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.d11f36f6d357cda45819a310feaf195d.svg";
export { ForwardRef as ReactComponent };